import { createContext, useContext, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from '../utils/api'

const FormConfigContext = createContext()

export const FormConfigProvider = ({ children }) => {
  const { formId } = useParams()
  const [formConfig, setFormConfig] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchFormConfig = async () => {
      try {
        const { data } = await axios.get('/testimonial/get-form', {
          params: { id: formId }
        })

        if (!data.success) {
          throw new Error(data.message || 'Failed to fetch form configuration')
        }

        setFormConfig(data.payload.form)
      } catch (err) {
        console.error('Error fetching form config:', err)
        setError(err.message || 'Failed to load form configuration. Please try again later.')
      } finally {
        setIsLoading(false)
      }
    }

    if (formId) {
      fetchFormConfig()
    } else {
      setError('No form ID provided')
      setIsLoading(false)
    }
  }, [formId])

  return <FormConfigContext.Provider value={{ formConfig, isLoading, error }}>{children}</FormConfigContext.Provider>
}

export const useFormConfig = () => {
  const context = useContext(FormConfigContext)
  if (!context) {
    throw new Error('useFormConfig must be used within a FormConfigProvider')
  }
  return context
}
